export const APASH_PRODUCT_EXTERNAL_ID = 'productExternalId';
